<script setup lang="ts">
import type { BlockHighlightsFragment, PressThumbFragment } from '#graphql-operations'

interface HighlightsPressProps {
  data: BlockHighlightsFragment
}

const props = defineProps<HighlightsPressProps>()

const pressItems = computed(() => props.data.press.filter(Boolean) as PressThumbFragment[])
</script>

<template>
  <Section padded class="blockHighlights c-white py-7 bg-wine lg:py-15">
    <div class="container layout-grid">
      <div class="col-span-full space-y-10 lg:col-span-8 lg:col-start-3 lg:space-y-15">
        <Text v-if="data.heading" class="richtext-simple typo-serif-4 text-center" :html="data.heading" />
        <ul class="gap-1.5 grid grid-cols-2 lg:gap-4 lg:grid-cols-8">
          <li
            v-for="(press, i) in pressItems"
            :key="press.id"
            class="lg:col-span-2 lg:col-start-$start"
            :class="{ 'desktop-only': i > 1 }"
            :style="{ '--start': i * 3 + 1 }"
          >
            <CardPress :data="press" />
          </li>
        </ul>
      </div>
      <ul class="mt-5 flex gap-2 col-span-full w-full items-center justify-center lg:mt-12.5">
        <li v-for="link in data.links" :key="link!.id">
          <ButtonLink :link="link?.customLink" />
        </li>
      </ul>
    </div>
  </Section>
</template>
